module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("9HiLD"))).then(() => parcelRequire('37nVf'));